module.exports = __webpack_public_path__ + "img/step-03-apk.b590230a.svg";